import { render, staticRenderFns } from "./DocumentPasses.vue?vue&type=template&id=010080a4&scoped=true"
import script from "./DocumentPasses.vue?vue&type=script&lang=js"
export * from "./DocumentPasses.vue?vue&type=script&lang=js"
import style0 from "./DocumentPasses.vue?vue&type=style&index=0&id=010080a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010080a4",
  null
  
)

export default component.exports